import api, { ApiResponse } from './api';

export type PromptStatus =
  | 'proposed' | 'approved' | 'rejected' | 'queued' | 'generating' | 'succeeded' | 'failed';

export interface GenerationPrompt {
  id: string;
  run_id: string;
  source_creative_id: string | null;
  prompt: string;
  status: PromptStatus;
  result_creative_id: string | null;
  error_message: string | null;
  params: Record<string, unknown>;
  source_url: string | null;
  result_url: string | null;
}

export interface GenerationRun {
  id: string;
  status: string;
  kind: string;
  source_creative_ids: string[];
  model: string;
  created_at: string;
  error_message: string | null;
}

export const creativeGenerationService = {
  createRunFromAds: async (adIds: string[]): Promise<GenerationRun & { prompts_added: number }> => {
    const res = await api.post<ApiResponse<GenerationRun & { prompts_added: number }>>(
      '/creative-generation/runs', { ad_ids: adIds });
    return res.data.data!;
  },

  listRuns: async (limit = 25): Promise<GenerationRun[]> => {
    const res = await api.post<ApiResponse<GenerationRun[]>>('/creative-generation/runs/query', { limit });
    return res.data.data ?? [];
  },

  getRun: async (runId: string): Promise<{ run: GenerationRun; prompts: GenerationPrompt[] }> => {
    const res = await api.get<ApiResponse<{ run: GenerationRun; prompts: GenerationPrompt[] }>>(
      `/creative-generation/runs/${runId}`);
    return res.data.data!;
  },

  decide: async (runId: string, promptIds: string[], status: 'approved' | 'rejected'): Promise<number> => {
    const res = await api.post<ApiResponse<{ changed: number }>>(
      `/creative-generation/runs/${runId}/decide`, { prompt_ids: promptIds, status });
    return res.data.data!.changed;
  },

  generate: async (runId: string): Promise<number> => {
    const res = await api.post<ApiResponse<{ queued: number }>>(
      `/creative-generation/runs/${runId}/generate`, {});
    return res.data.data!.queued;
  },
};
